import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const BarChartUrbanTV = (props) => {
  const setAqiColor = (x) => {
    if (x <= 50) {
      return "#0f9d63";
    } else if (x > 50 && x <= 100) {
      return "#ffd700";
    } else if (x > 100 && x <= 150) {
      return "#ff8c00";
    } else if (x > 150 && x <= 200) {
      return "#ff0000";
    } else if (x > 200 && x <= 300) {
      return "#800080";
    } else if (x > 300) {
      return "#a52a2a";
    } else {
      return "#8f8f8f";
    }
  };

  let labels = [];
  if (props.type === "gasAndParticles") {
    labels = ["AQI", "PM2.5", "PM10", "CO", "O3", "NO2", "SO2"];
  } else if (props.type === "onlyParticles") {
    labels = ["AQI", "PM2.5", "PM10"];
  }

  let chartData = [];
  if (props.type === "gasAndParticles") {
    chartData = [
      props.data.AQI,
      props.data.PM25AQI,
      props.data.PM10AQI,
      props.data.COAQI,
      props.data.O3AQI,
      props.data.NO2AQI,
      props.data.SO2AQI,
    ];
  } else if (props.type === "onlyParticles") {
    chartData = [props.data.AQI, props.data.PM25AQI, props.data.PM10AQI];
  }

  let titleText = "";
  if (props.typeBasedOfTime === "online") {
    titleText = "شاخص کیفیت هوا - برخط";
  } else if (props.typeBasedOfTime === "daily") {
    titleText = "شاخص کیفیت هوا - روزانه";
  }

  let chartColors = [];
  if (props.type === "gasAndParticles") {
    chartColors = [
      setAqiColor(props.data.AQI),
      setAqiColor(props.data.PM25AQI),
      setAqiColor(props.data.PM10AQI),
      setAqiColor(props.data.COAQI),
      setAqiColor(props.data.O3AQI),
      setAqiColor(props.data.NO2AQI),
      setAqiColor(props.data.SO2AQI),
    ];
  } else if (props.type === "onlyParticles") {
    chartColors = [
      setAqiColor(props.data.AQI),
      setAqiColor(props.data.PM25AQI),
      setAqiColor(props.data.PM10AQI),
    ];
  }

  const data = {
    labels,
    datasets: [
      {
        label: "داده های امروز",
        data: chartData,
        backgroundColor: chartColors,
      },
    ],
  };

  return (
    <Bar
      style={{ height: "100vh", width: "auto" }}
      className="mx-auto my-0"
      data={data}
      options={{
        responsive: true,
        maxBarThickness: 90,
        minBarLength: 30,
        plugins: {
          title: {
            display: true,
            text: titleText,
            padding: 20,
            font: {
              size: "40vw",
              weight: "bold",
            },
            color: "#ffffff",
          },
          legend: {
            display: false,
          },
          datalabels: {
            display: true,
            color: "#ffffff",
            font: {
              size: "25",
              weight: "bold",
            },
            anchor: "end", // Center horizontally
            align: "end", // Center vertically
            textAlign: "center",
            offset: 0, // No offset needed
            formatter: (value) => value.toFixed(0), // Format values as integers
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            border: {
              color: "#ffffff",
              width: 2,
            },
            ticks: {
              color: "#ffffff",
              font: {
                size: "20vw",
                weight: "bold",
              },
            },
            grid: {
              display: false,
            },
          },
          x: {
            border: {
              color: "#ffffff",
              width: 2,
            },
            ticks: {
              color: "#ffffff",
              font: {
                size: "30vw",
                weight: "bold",
              },
            },
            grid: {
              display: false,
            },
          },
        },
      }}
    />
  );
};

export default BarChartUrbanTV;
